export default {
    MINIMUM_NOB_SIZE: 15
}